import styles from './UtilityBar.module.scss';

interface UtilityBarProps {
  children: React.ReactNode;
  label: string;
  id?: string;
}

export const UtilityBar: React.FC<UtilityBarProps> = ({ children, label, id }) => (
  <div id={id} className={styles.bar}>
    <p className={styles.label}>{label}</p>
    {children}
  </div>
);
